import { call, put, takeLatest } from 'redux-saga/effects';
import { getActions } from 'services/contentfulApi';

import {
  FETCH_ACTIONS_ERROR,
  FETCH_ACTIONS_SUCCESS,
  REQUEST_ACTIONS
} from 'actions/types';

export function* fetchActions(action) {
  if (!action) return;
  try {
    const data = yield call(getActions);
    yield put({ type: FETCH_ACTIONS_SUCCESS, data: data });
  } catch (err) {
    yield put({ type: FETCH_ACTIONS_ERROR, err });
  }
}

export function* watchFetchActions() {
  yield takeLatest(REQUEST_ACTIONS, fetchActions);
}



// WEBPACK FOOTER //
// ./src/sagas/actions.js